import { State } from '@progress/kendo-data-query';
import { toODataString } from '@progress/kendo-data-query/dist/npm/odata.operators';
import { Item } from 'src/types/itemList';
import { ItemSearchRequest } from 'src/types/itemSearchRequest';
import { ODataResponse } from 'src/types/oDataResponse';
import { post } from './Api';

// const getCurrentRawSearch = (dataState) => {
//   var odataString = toODataString(dataState);
//   if (dataState.sort?.length ?? 0 === 0) {
//     odataString += '&$orderby=ItemNumber_t_sort';
//   }
//   return odataString;
// };

async function getByItemNumber(itemNumber: string): Promise<Item> {
  const searchRequest: ItemSearchRequest = {
    searchText: itemNumber,
    availableOnly: false,
    exactMatch: true,
    history: false,
    historyStartDate: undefined,
    historyEndDate: undefined,
    vendorNumber: 0,
    customerNumber: 0,
    warehouseCode: '',
  };

  let response = await post<ODataResponse<Item>>('/odata/item/?$count=false', searchRequest);
  if (response?.value?.length ?? 0 > 0) {
    var r = response.value.find((item) => item.itemNumber === itemNumber);
    if (r) {
      return r;
    }

    return response.value[0];
  } else {
    return null;
  }
}

async function getItems(dataState: State, searchText: string): Promise<ODataResponse<Item>> {
  //Deep copy state, don't mutate the actual table state
  let odataState = { ...dataState };
  odataState.filter = { ...dataState.filter };
  odataState.filter.filters = [...dataState.filter.filters];

  // Add orderBy to the odataState
  odataState.sort = [{ field: 'itemNumber', dir: 'asc' }];

  const searchRequest: ItemSearchRequest = {
    searchText: searchText,
    availableOnly: false,
    exactMatch: false,
    history: false,
    historyStartDate: undefined,
    historyEndDate: undefined,
    vendorNumber: 0,
    customerNumber: 0,
    warehouseCode: '',
  };

  odataState.filter.filters.push({
    field: 'Active_b',
    operator: 'eq',
    value: 'true',
  });

  let odataString = toODataStringWithSelect(odataState, ['ItemId', 'ItemNumber', 'Name', 'Description', 'CatalogHeader', 'CatalogSubHeader', 'Image']);
  return post<ODataResponse<Item>>(`/odata/item/?$count=false&${odataString}`, searchRequest);
}

function toODataStringWithSelect(dataState: State, selectFields: string[]): string {
  let odataString = toODataString(dataState);
  if (!odataString.endsWith('&') && !odataString.endsWith('?')) {
    odataString += '&';
  }
  odataString += `$select=${selectFields.join(',')}`;
  return odataString;
}

export default {
  getItems,
  getByItemNumber,
};
